import i18next from "i18next";
import { __UrlParams, __Utils } from "./core";

/** Import language Files */
import { TRANSLATE_TOOL_URL } from "./config/config.App";

interface LangManagerInterface {
  onReady?: Function;
}

export default class LangManager {
  private defaultLang: string = "en";
  private currentLang: string = "";
  private onReady: Function | undefined;
  private isLoaded: boolean = false;

  constructor(_props?: LangManagerInterface) {
    this.currentLang = __UrlParams.props.locale;
  }

  async init({ onReady }: any) {
    await i18next.init({
      lng: this.currentLang, // if you're using a language detector, do not define the lng option
      fallbackLng: this.defaultLang,
      debug: false,
      interpolation: {
        escapeValue: true, // not needed for react!!
      },
      keySeparator: ".",
      resources: {},
      partialBundledLanguages: true,
      ns: [],
    });
    // i18next.addR
    await this.loadLanguageAsync(i18next);

    if (typeof onReady === "function") onReady();

    return i18next;
  }

  async loadLanguageAsync(_i18next: any) {
    const lang = __Utils.getQueryParams().lang;
    // If the same language

    return await fetch(
      `${TRANSLATE_TOOL_URL}translate-widget/export/api/${lang}?gameID=${
        __Utils.getQueryParams().gameID
      }`
    )
      .then(async (res) => {
        let languages = await res.json();
        _i18next.addResourceBundle(lang, "n", languages);
        _i18next.loadNamespaces(["n"]);
        this.isLoaded = true;
      })
      .catch((err) => {
        console.warn("LANGUAGE API ERROR", err);
      });
  }

  getIsLoaded() {
    return this.isLoaded;
  }

  translate(_Key: string) {
    return i18next.t(_Key);
  }

  convertUnicode(input: any) {
    if (!input) return "";
    return input.replace(/\\u[0-9a-fA-F]{4}/g, function (a: any, b: any) {
      var charcode = parseInt(b, 16);
      return String.fromCharCode(charcode);
    });
  }

  replace(_Key: string, _Replace: any): string {
    return this.convertUnicode(i18next.t(_Key, _Replace));
  }
}
